import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Client-side gate for the Platform Administration Center. The REAL enforcement is
// server-side (require_platform_admin on every /admin/* endpoint); this only keeps the
// UI tidy for non-admins.
export default function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user === undefined) return null;
  if (!user?.is_platform_admin) return <Navigate to="/dashboard" replace />;
  return children;
}
